import { Translate } from '@chipinside/translate'
import { Box, Stack, Typography } from '@mui/material'
import { ArrowUpDown, CornerDownLeft } from 'lucide-react'
import { ReactNode } from 'react'

function KeyHint({ icon, label }: { icon: ReactNode; label: string }) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75 }}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'grey.100',
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          color: 'text.secondary',
          display: 'flex',
          height: 20,
          justifyContent: 'center',
          width: 20,
        }}
      >
        {icon}
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
    </Stack>
  )
}

export function SearchFooter({
  hasSearch,
  resultCount,
}: {
  resultCount: number
  hasSearch: boolean
}) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        background: 'white',
        borderTop: '1px solid #e1e1e1',
        display: 'flex',
        justifyContent: 'space-between',
        px: 2,
        py: 1,
        zIndex: 1,
      }}
    >
      <Stack direction="row" sx={{ gap: 2 }}>
        <KeyHint
          icon={<ArrowUpDown size={12} />}
          label={Translate({ messageKey: 'search_shortcut_navigate' })}
        />
        <KeyHint
          icon={<CornerDownLeft size={12} />}
          label={Translate({ messageKey: 'search_shortcut_open' })}
        />
      </Stack>
      {hasSearch && (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {resultCount} {Translate({ messageKey: 'results' })}
        </Typography>
      )}
    </Box>
  )
}
